import React = require("react");
import {PieChartWithLabels} from "../../../../../../dashboard/widgets/charts/PieChartWithLabels";
import {Legend} from "../../../../../../components/charts/Legend";
import {CoffeeConsumptionStatistics, CoffeeMachineJsonMapper} from "../../../data/CoffeeMachineJsonMapper";
import {JSONContinueConsumptionsWidgetTexts} from "../../CoffeeMachineDashboard";
import {Widget, WidgetProps} from "./Widget";
import {VeBoxCard} from "../../../../../../components/card/VeBoxCard";
import AutoSizer from "react-virtualized-auto-sizer";

interface ContinueDispensingConsumptionsWidgetProps extends WidgetProps {
    texts: JSONContinueConsumptionsWidgetTexts;
    data: CoffeeConsumptionStatistics;
    key: any;
}

interface WidgetState {
    selectedItemName: string;
}

export const CUNSUMPTION_FILTER_EVENT: string = "CUNSUMPTION_FILTER_EVENT";

export class ContinueDispensingConsumptionsWidget
    extends Widget<ContinueDispensingConsumptionsWidgetProps, WidgetState> {

    constructor(props) {
        super(props);
        this.state = {selectedItemName: null};
    }

    public widgetRender() {

        const legendItems = [
            {color: "rgba(255, 153, 38, 0.7)", name: this.props.texts.continueConsumptions, value: 1},
            {color: "rgba(228, 217, 197, 0.7)", name: this.props.texts.presetConsumptions, value: 2},
            {color: "rgba(168,168,168,0.7)", name: this.props.texts.unknownConsumptions, value: 3},
        ];

        const preparedData = CoffeeMachineJsonMapper.toConsumptionByType(this.props.data, legendItems);

        return (
            <VeBoxCard className={"no-margin"}>
                <VeBoxCard.Header title={this.props.texts.title}/>
                <VeBoxCard.Body className="continue-dispensing-consumptions-widget__content no-padding">
                    <div className="pie-chart__legend__container">
                        <Legend
                            items={legendItems}
                            selectedItemName={this.state.selectedItemName}
                            onItemHover={this.setSelectedItem}
                        />
                    </div>
                    <div className="pie-chart__graph">
                        <AutoSizer style={{width: "auto", height: "auto"}}>
                            {({height, width}) =>
                                <PieChartWithLabels
                                    donutOptions={{activeDonut: false}}
                                    width={width}
                                    height={height}
                                    radiusRatio={2}
                                    data={preparedData}
                                    showPercentage={true}
                                    showFrequency={false}
                                    showIcon={false}
                                    noDataMessage={"No data"}
                                    labelLineDefaultLength={20}
                                    groupingThreshold={15}
                                    selectedItem={this.state.selectedItemName}
                                    labelsOptions={{externalLegend: true}}
                                    onPathOver={this.setSelectedItem}
                                />
                            }
                        </AutoSizer>
                    </div>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }

    private setSelectedItem = (itemName) => {
        this.setState({selectedItemName: itemName});
        this.props.controller.addEvent({
            type: CUNSUMPTION_FILTER_EVENT,
            data: this.mapItemName(itemName),
        });
    }

    private mapItemName = (itemName: string) => {
        switch (itemName) {
            case this.props.texts.continueConsumptions : {
                return true;
            }
            case this.props.texts.presetConsumptions : {
                return false;
            }
            case this.props.texts.unknownConsumptions : {
                return undefined;
            }
        }
        return null;
    }
}
